import React from 'react';
import {SecondaryCollapsibleSection} from "../../../../../../../elements/collapsableSection/secondary/SecondaryCollapsibleSection";
import {ValidationResult} from "../../../../../../../elements/validator/component/ValidationComponent";
import {SubtractionLine} from "../SubtractionLine/SubtractionLine";
import {DependantValidationComponent} from "../../../../../../../elements/validator/dependant/DependantValidationComponent";
import {ServiceHistoryMultipliersRequestValidator} from "../../../../../../../elements/validator/Validator";
import {
    selectServiceHistoryMultipliers,
    selectFullHistorySubtraction,
    selectPartHistorySubtraction,
    selectNoHistorySubtraction
} from "../../../toolSettingsSlice";
import {UpdateBotToolSettingsRequest, UpdateServiceHistoryMultipliersRequest, UpdateSubtractionRequest} from "../../../../../../../../api/generated";
import styles from "./VehicleServiceHistoryDiscount.module.css";

interface Props {
    getMessage: (f: string) => string;
    updateValidationStatus: (status: ValidationResult<UpdateBotToolSettingsRequest>) => void;
    updateServiceHistoryMultipliers: (fieldName: string, value: UpdateSubtractionRequest) => void;
    disabled?: boolean;
}

export const VehicleServiceHistoryDiscount: React.FC<Props> = ({
    getMessage,
    updateValidationStatus,
    updateServiceHistoryMultipliers,
    disabled
}) => {
    const getErrorMessageForField = (fieldName: string): string | undefined => {
        const rawErrors = getMessage("serviceHistoryMultipliers");
        if (rawErrors) {
            try {
                return JSON.parse(rawErrors)[fieldName];
            } catch (e) {
                // Ignore JSON parse errors
            }
        }
        return undefined;
    };

    return (
        <DependantValidationComponent<UpdateServiceHistoryMultipliersRequest, UpdateBotToolSettingsRequest>
            onChange={v => v}
            updateValidationStatus={updateValidationStatus}
            fieldName={'serviceHistoryMultipliers'}
            required={false}
            selector={selectServiceHistoryMultipliers}
            validator={ServiceHistoryMultipliersRequestValidator}
            label={"Service History Multipliers"}
            disabled={disabled}
            anchorValueSelector={(state) => state.toolSettings.updateRequest.botPublicId}
            child={() =>
                <SecondaryCollapsibleSection disabled={disabled} title={"Service History Discount"}>
                    <div className={styles.wrapper}>
                        <SubtractionLine
                            title={"If history is Full"}
                            fieldName={"fullHistorySubtraction"}
                            errorMessage={getErrorMessageForField("fullHistorySubtraction")}
                            subtractionFieldSelector={selectFullHistorySubtraction}
                            updateMultipliers={updateServiceHistoryMultipliers}
                            disabled={disabled}
                        />
                        <SubtractionLine
                            title={"If history is Partial"}
                            fieldName={"partHistorySubtraction"}
                            errorMessage={getErrorMessageForField("partHistorySubtraction")}
                            subtractionFieldSelector={selectPartHistorySubtraction}
                            updateMultipliers={updateServiceHistoryMultipliers}
                            disabled={disabled}
                        />
                        <SubtractionLine
                            title={"If history is Not Available"}
                            fieldName={"noHistorySubtraction"}
                            errorMessage={getErrorMessageForField("noHistorySubtraction")}
                            subtractionFieldSelector={selectNoHistorySubtraction}
                            updateMultipliers={updateServiceHistoryMultipliers}
                            withBorderLine={false}
                            disabled={disabled}
                        />
                    </div>
                </SecondaryCollapsibleSection>
            }
        />
    );
};

